// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3311 ? "5ffe1889" : chunkId) + "." + {"395":"8ec625984172e56a","1413":"91f081e246a46ed6","3311":"805a9131a9e40155","6793":"f57464ca23fa9330"}[chunkId] + ".js";
};